import { Box } from '../../../Box';
import { ColoredChip } from '../../../ColoredChip';
import { Tooltip } from '../../../Tooltip';
import { useIsDesktop } from '../../../hooks';

/**
 * Свойства компонента {@link Badge}
 */
interface BadgeProps {
  /**
   * Заголовок значка.
   */
  title?: string;

  /**
   * Ширина чипа.
   */
  width?: string | number;

  /**
   * Описание значка, отображаемое при наведении.
   */
  description?: string;

  /**
   * Цвет значка.
   */
  color?: 'gray' | 'green' | 'orange' | 'red' | 'blue' | 'velvet';

  /**
   * Размер значка.
   */
  size?: 'extraSmall' | 'small';
}

/**
 * Badge - компонент для отображения значка с опциональным описанием.
 *
 * @public
 * @param title - Заголовок значка.
 * @param description - Описание значка, отображаемое при наведении.
 * @param color - Цвет значка.
 * @param size - Размер значка.
 * @param width - Ширина чипа.
 * @returns Возвращает JSX-элемент представляющий компонент Badge.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link BadgeProps}
 */
export const Badge = ({
  title = '',
  description = '',
  color,
  size = 'small',
  width,
}: BadgeProps) => {
  const isDesktop = useIsDesktop();

  return (
    <Box>
      <Tooltip disabled={!isDesktop} title={description} placement="left">
        <span>
          <ColoredChip
            width={width}
            fullWidth
            size={size}
            color={color === 'velvet' ? 'purple' : color || 'blue'}
            label={title}
          />
        </span>
      </Tooltip>
    </Box>
  );
};
